import MaintenancePage from "../../components/feature/MaintenancePage";
import SEOHead from "../../components/feature/SEOHead";

const LOGO =
  "https://storage.readdy-site.link/project_files/9ee712e0-c50a-4d2b-9956-d4b4346de3f4/b4358a4f-b46f-4c11-af49-3c8e74baee79_FC8_LOGO.png?v=eea0bf80ba223d3fbe4155bc4237aaeb";

const siteUrl = (import.meta.env.VITE_SITE_URL as string) || "https://example.com";

const schema = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  "@id": `${siteUrl}/fc8au#website`,
  name: "FC8AU",
  url: `${siteUrl}/fc8au`,
  inLanguage: "en-AU",
  description:
    "FC8AU website is currently undergoing scheduled maintenance. We appreciate your patience while we improve your online gaming experience.",
  potentialAction: {
    "@type": "SearchAction",
    target: `${siteUrl}/fc8au?q={search_term_string}`,
    "query-input": "required name=search_term_string",
  },
};

export default function Fc8au() {
  return (
    <>
      <SEOHead
        title="FC8AU | We'll Be Back Shortly — Maintenance Mode"
        description="FC8AU website is currently undergoing scheduled maintenance. We appreciate your patience while we improve your experience."
        keywords="FC8AU, FC8, online gaming, maintenance"
        canonicalPath="/fc8au"
        schemaJson={schema}
        ogImage={LOGO}
        ogImageAlt="FC8AU Logo"
        siteName="FC8AU"
      />
      <MaintenancePage
        logoSrc={LOGO}
        logoAlt="FC8AU Logo"
        accentColor="#C8D6E5"
        glowRgb="200,214,229"
        bgFrom="#151515"
        whatsappLink="https://wa.me/61416099801"
        telegramLink="https://t.me/FC8AU"
      />
    </>
  );
}
